<template>
  <div
    class="auth-layout h-screen overflow-hidden bg-[url('/Login.png')] bg-cover bg-no-repeat"
    data-cy="auth-layout"
  >
    <div class="grid h-screen w-full overflow-auto">
      <div
        class="relative flex flex-col items-center justify-center bg-white px-4 py-10 lg:mx-5 lg:my-4 lg:w-1/2 lg:rounded-2xl lg:px-10"
      >
        <Logo v-if="notLoginOrRegister" class="left-30 absolute top-4 lg:left-12" />
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Logo from '@/components/Brand/LogoWhite.vue';
import { computed } from 'vue';
import router from '@/router';

const notLoginOrRegister = computed(
  () => router.currentRoute.value.name !== 'login' && router.currentRoute.value.name !== 'register',
);
</script>
